import { render, staticRenderFns } from "./WordpressInstallPlugin.vue?vue&type=template&id=50e325f4&scoped=true&"
import script from "./WordpressInstallPlugin.vue?vue&type=script&lang=js&"
export * from "./WordpressInstallPlugin.vue?vue&type=script&lang=js&"
import style0 from "./WordpressInstallPlugin.vue?vue&type=style&index=0&id=50e325f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e325f4",
  null
  
)

export default component.exports